import { Search, Waves, User } from "lucide-react";
import { Link, useLocation } from "wouter";
import { useAuth } from "@/hooks/useAuth";
import { useState } from "react";
import SearchModal from "./SearchModal";
import logoImageDark from "@assets/Live_(1500_x_500_px)_(2)_1780520244305.png";

interface HeaderProps {
  onLocationSelect?: (location: any) => void;
}

export default function Header({ onLocationSelect }: HeaderProps) {
  const { isAuthenticated } = useAuth();
  const [location] = useLocation();
  const [showSearchModal, setShowSearchModal] = useState(false);

  const spotsActive = location === "/";
  const mobileSpotsActive = spotsActive || location === "/conditions";
  const profileActive = location === "/profile";

  return (
    <header className="sticky top-0 z-50" style={{ background: "rgba(3,10,20,.96)", borderBottom: "1px solid rgba(255,255,255,0.05)", backdropFilter: "blur(16px)" }}>
      <div className="mx-auto px-5 py-3 max-w-[1180px] flex items-center justify-between gap-5">
        <Link href="/" className="shrink-0" aria-label="LiveSwell home">
          <img src={logoImageDark} alt="LiveSwell" className="h-8 object-contain object-left" />
        </Link>
        <div className="flex items-center gap-1">
          {isAuthenticated ? (
            <>
              {/* Spots */}
              <Link href="/" className="w-8 h-8 flex items-center justify-center rounded-xl transition-colors"
                  style={{
                    background: mobileSpotsActive ? "rgba(16,185,129,0.12)" : "rgba(255,255,255,0.05)",
                    color: mobileSpotsActive ? "#34d399" : "#475569",
                  }}
                  title="Surf spots"
                ><Waves size={15} />
              </Link>

              {/* Search */}
              <button
                onClick={() => setShowSearchModal(true)}
                className="w-8 h-8 flex items-center justify-center rounded-xl transition-colors"
                style={{ background: "rgba(255,255,255,0.05)", color: "#475569" }}
                title="Search surf spots"
                data-testid="button-search"
              >
                <Search size={15} />
              </button>

              {/* Profile */}
              <Link href="/profile" className="w-8 h-8 flex items-center justify-center rounded-xl transition-colors"
                  style={{
                    background: profileActive ? "rgba(16,185,129,0.12)" : "rgba(255,255,255,0.05)",
                    color: profileActive ? "#34d399" : "#475569",
                  }}
                  title="Profile"
                ><User size={15} />
              </Link>
            </>
          ) : (
            <>
            <button
              className="px-3 py-1.5 rounded-xl text-[12px] font-semibold text-white transition-opacity hover:opacity-80"
              style={{ background: "rgba(16,185,129,0.15)", border: "1px solid rgba(16,185,129,0.3)" }}
              data-testid="button-open-auth"
              onClick={() => window.location.href = "/login"}
            >
              Sign In
            </button>
            <Link
              href="/sign-up"
              className="whitespace-nowrap px-3 py-1.5 rounded-xl text-[12px] font-semibold text-[#030a14] bg-emerald-400 transition-opacity hover:opacity-80"
              data-testid="button-sign-up"
            >
              Sign Up
            </Link>
            </>
          )}
        </div>
      </div>

      <SearchModal
        isOpen={showSearchModal}
        onClose={() => setShowSearchModal(false)}
        onLocationSelect={(loc) => {
          if (onLocationSelect) onLocationSelect(loc);
          setShowSearchModal(false);
        }}
        initialQuery=""
      />
    </header>
  );
}
